import PageLayout from 'pages/RubricsGetStarted/PageLayout';
import PageProvider from 'pages/RubricsGetStarted/PageProvider';

const RubricsGetStartedPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default RubricsGetStartedPage;
